import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '../../Atoms/Button';

const actionIconMapping = {
  edit: 'pencil',
  delete: 'trash',
};

const ActionCell = ({
  isRowLocked,
  cell,
  row,
  actions,
  onAction,
  buttonClass = 'mb-0 ml-1 p-0 text-gray',
  iconClass = '',
}) => {
  return (
    <>
      {cell.column.id === 'action' && isRowLocked && (
        <div className="text-center">
          <div
            className="spinner-border text-gray-500 spinner-border-sm"
            role="status"
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )}

      {cell.column.id === 'action' && !isRowLocked && (
        <div className="d-flex justify-content-around">
          {actions.map((action) => {
            let icon = actionIconMapping[action] || action;
            let title = action;
            if (typeof action === 'object' && action) {
              icon = actionIconMapping[action?.icon] || action?.icon;
              title = action?.title || action?.icon;
            }
            return (
              <Button
                key={icon}
                variant="link"
                className={buttonClass}
                icon={icon}
                iconClass={iconClass}
                title={title}
                onClick={() => onAction(action, row.original)}
              />
            );
          })}
        </div>
      )}
    </>
  );
};

ActionCell.propTypes = {
  cell: PropTypes.shape({
    column: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  isRowLocked: PropTypes.bool,
  row: PropTypes.shape({
    original: PropTypes.shape({}),
  }),
  actions: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        icon: PropTypes.string.isRequired,
        title: PropTypes.string,
      }),
    ]),
  ),
  onAction: PropTypes.func,
  buttonClass: PropTypes.string,
  iconClass: PropTypes.string,
};

export default ActionCell;
